<template>
  <div>
    <h1>比赛ID ：{{form.id}} , 当前状态:<span style="color: darkred;font-size: 30px">{{form.statusdesc}}</span></h1>
    <el-row>
      <el-col :span="12">
        <el-form label-width="120px">
          <el-form-item label="比赛描述" prop="name" >
            <el-input v-model="form.desc"></el-input>
          </el-form-item>
          <el-form-item label="比赛年">
            <el-input v-model="form.year"></el-input>
          </el-form-item>
          <el-form-item label="比赛月">
            <el-input v-model="form.month"></el-input>
          </el-form-item>
          <el-form-item label="比赛日">
            <el-input v-model="form.day"></el-input>
          </el-form-item>
          <el-form-item label="报名费">
            <el-input v-model="form.amount"></el-input>
          </el-form-item>
          <el-form-item label="地址">
            <el-input v-model="form.address"></el-input>
          </el-form-item>
          <el-form-item label="报名开始年">
            <el-input v-model="form.syear"></el-input>
          </el-form-item>
          <el-form-item label="报名开始月">
            <el-input v-model="form.smonth"></el-input>
          </el-form-item>
          <el-form-item label="报名开始日">
            <el-input v-model="form.sday"></el-input>
          </el-form-item>
          <el-form-item label="报名开始时间">
            <el-input v-model="form.stime"></el-input>
          </el-form-item>
          <el-form-item label="报名结束年">
            <el-input v-model="form.eyear"></el-input>
          </el-form-item>
          <el-form-item label="报名结束月">
            <el-input v-model="form.emonth"></el-input>
          </el-form-item>
          <el-form-item label="报名结束日">
            <el-input v-model="form.eday"></el-input>
          </el-form-item>
          <el-form-item label="报名结束时间">
            <el-input v-model="form.etime"></el-input>
          </el-form-item>
          <el-form-item label="规则或附件（外部链接）">
            <el-input v-model="form.rule"></el-input>
          </el-form-item>
<!--          <el-form-item>-->
<!--            <el-upload-->
<!--                    class="avatar-uploader"-->
<!--                    :action="baseUrl+'imgserver/upload'"-->
<!--                    :show-file-list="false"-->
<!--                    :multiple="false"-->
<!--                    :with-credentials="true"-->
<!--                    :on-success="handleAvatarSuccess"-->
<!--                    :before-upload="beforeAvatarUpload"-->
<!--                    :on-error	="handleAvatarError">-->
<!--              <el-button size="small" type="primary" class="teal">点击上传规则,格式pdf,jpg等</el-button>-->
<!--              <p style="color: gray;font-size: 10px">大小不可超过5MB</p>-->
<!--            </el-upload>-->
<!--            <p>-->
<!--                     <span v-if="form.rule!==''" >-->
<!--                       <a :href="baseUrl+'imgserver/'+form.rule"  target="_blank">查看当前已上传的文件{{form.rule}}</a>-->
<!--                       <el-button size="small" type="primary" class="teal" @click="delRule">点击删除规则</el-button>-->
<!--                     </span>-->
<!--              <span v-else>当前没有已经上传的规则</span>-->
<!--            </p>-->
<!--          </el-form-item>-->
        </el-form>
      </el-col>
      <el-col :span="12">
        <p>请设置分组信息</p>
        <el-button @click="groupOut=JSON.stringify(form.group)">导出</el-button><el-button @click="form.group=JSON.parse(groupOut)">导入</el-button>
        <br>
        <textarea v-model="groupOut" style="width: 600px;height: 100px"></textarea>
        <br>

        <el-button @click="form.group.push({})">添加新的分组</el-button>
        <table >
          <thead>
          <tr>
            <th width="150px">
              组名
            </th>
            <th width="150px">
              开赛具体时间
            </th>
            <th width="150px">
              升级后的下一级
            </th>
            <th width="150px">
              备注
            </th>
            <th width="150px">
              操作
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item,index) in form.group">
            <td>
              <el-input v-model="item.name"></el-input>
            </td>
            <td>
              <el-input v-model="item.time"></el-input>
            </td>
            <td>
              <el-input v-model="item.next"></el-input>
            </td>
            <td>
              <el-input v-model="item.remark"></el-input>
            </td>
            <td>
              <el-button type="danger" @click="delGroup(index)">删除</el-button>
            </td>
          </tr>
          </tbody>
        </table>
      </el-col>
    </el-row>

    <el-button @click="save"  style="padding: 20px" type="warning">保存</el-button>
    <div >
      <el-button type="primary" @click="nchange(2)" >设置为正在报名</el-button>
      <el-button type="primary" @click="nchange(1)">设置为未开始报名</el-button>
      <el-button type="primary" @click="nchange(3)">设置为已结束报名</el-button>
      <el-button type="danger"  @click="cancelchange">设置为已取消/不显示</el-button>
    </div>
  </div>
</template>

<script>
  import {baseUrl} from "../../config";
  export default {
    name: "contestDetail",
    data(){
      return{
        groupOut:'',
        baseUrl:baseUrl,
        form:{}
      }
    },

    mounted() {
      this.getData()
    },
    methods:{
      delGroup(index){
        this.$confirm('请确认是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.form.group.splice(index,1)
        }).catch(() => {
        });
      },
      delRule(){
        this.form.rule=''
        this.save()
      },
      nchange(status) {
        this.form.status=status
        this.save()
      },
      cancelchange(){
        this.$confirm('请确认是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.nchange(4)
        }).catch(() => {
        });
      },
      save(){
        let copyfrom=JSON.parse(JSON.stringify(this.form));
        copyfrom.group=JSON.stringify(copyfrom.group)
        this.$http.postData('contest/'+this.$route.params.id,copyfrom,(data)=>{
          this.$message.success("修改成功");
          this.getData()
        },()=>{
          this.$message.error("修改失败")
        })
      },
      getData(){
        this.$http.getData('contest/'+this.$route.params.id,(data)=>{
          let group
          if(''===data.group){
            group=[]
          }else {
            group=JSON.parse(data.group)
          }
          data.group=group;
          this.form=data;
        },(data)=>{
          this.$message.error(data.message);
        })
      },
      handleAvatarSuccess(res, file) {
        this.$message.success("上传成功");
        this.form.rule=res.filename;
        this.save()
      },
      handleAvatarError(err, file, fileList){
        this.$message.error("上传照片失败，请重试");
      },
      beforeAvatarUpload(file) {
        const isLt5M = file.size / 1024 / 1024 < 5;
        if (!isLt5M) {
          this.$message.error("不能超过 5MB!");
        }
        return  isLt5M;
      },

    }
  }
</script>

<style scoped>

</style>
